import type { CatalogResource } from '../../types.js';
import { FEATURE_GROUP_KEYS } from '../feature-groups.js';
import { ROLE_KEYS } from '../roles.js';

const GROUP = FEATURE_GROUP_KEYS.NETWORK;
const defaultGrants = {
  [ROLE_KEYS.COMPANY_ADMIN]: 'all',
  [ROLE_KEYS.COMPANY_CREATOR]: 'all',
  [ROLE_KEYS.COMPANY_READER]: ['read'],
} as const;

export const network = [
  {
    key: 'network',
    name: 'Network',
    description: 'Supplier and partner directory',
    group: GROUP,
    actions: ['create', 'read', 'edit', 'archive'],
    grants: defaultGrants,
  },
] as const satisfies readonly CatalogResource[];
